module.exports = __webpack_public_path__ + "img/bold-square.307963e0.svg";